import { useStyles } from "../context";
import { CoreHotelsComponent, CORE_HOTELS_NAME } from "@b2bportal/core-types";

export const useHotelsStyles = (
  componentName: keyof typeof CoreHotelsComponent,
  defaultStyles?: object
) => {
  return useStyles(CORE_HOTELS_NAME, componentName, defaultStyles);
};
